module.exports = __webpack_public_path__ + "img/FI.dd5c04dc.png";